import React, { useState } from "react";
import StepsContext from "./StepsContext";
import { randomStr } from "../../../utils/helper";

const StepsState = (props) => {
  const [apiData, setApiData] = useState({ data: [], isLoading: false });
  const [apiDataOurTeam, setApiDataOurTeam] = useState({
    isLoading: false,
    data: [],
  });
  const [skill, setSkill] = useState([
    { id: randomStr(2), skill: "", parentageOfSkill: "" },
  ]);
  const [isBackgroundColor, setIsBackgroundColor] = useState(false);
  const [collId, setCollId] = useState();
  const [backImageToggle, setBackImageToggle] = useState(false);
  const [imageIs, setImageIs] = useState("");
  const [fromData, setFormData] = useState({
    title: "",
    subTitle: "",
    navMapId: "",
    isTitleShow: true,
    webId: localStorage.getItem("webId"),
    theme: 1,
    style: {
      ".step-by-step-section": {
        padding: "100px 0",
        "background-color": "rgb(255 255 255 / 100)",
      },
      ".step-by-step-section.bg-image": {
        "background-image": "",
      },
      ".step-by-step-section.bg-image::before": {
        "background-color": "",
      },
      ".step-by-step-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".step-by-step-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        "background-color": "rgb(255 73 124 / 0.2)",
        padding: "5px 20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
      },
      ".step-by-step-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: "rgb(0 0 0 / 100)",
      },
      ".step-by-step-section .stepdiv": {
        padding: "10px",
        "text-align": "center",
      },
      ".step-by-step-section .stepdiv .step-count": {
        width: "60px",
        height: "60px",
        color: "rgb(255 255 255 / 100)",
        "font-size": "30px",
        "font-weight": "600",
        padding: "12px 5px",
        "margin-bottom": "30px",
        "background-color": "rgb(255 73 124 / 100)",
        "border-radius": "50%",
      },
      ".step-by-step-section .stepdiv h4": {
        color: "rgb(0 0 0 / 100)",
        "font-weight": "600",
        "font-size": "20px",
        "margin-bottom": "15px",
      },
      ".step-by-step-section .stepdiv p": {
        color: "rgb(127 127 127 / 100)",
        "font-weight": "300",
        "font-size": "14px",
        "line-height": "1.6",
      },
    },
  });

  const [formDataChild, setFormDataChild] = useState({
    title: "",
    subTitle: "",
    description: "",
    order: 1,
    isTitleShow: true,
    webId: localStorage.getItem("webId"),
    navMapId: "",
  });

  const [settingFormData, setSettingFormData] = useState({
    ".step-by-step-section": {
      padding: "100px 0",
      "background-color": "rgb(255 255 255 / 100)",
    },
    ".step-by-step-section.bg-image": {
      "background-image": "",
    },
    ".step-by-step-section.bg-image::before": {
      "background-color": "",
    },
    ".step-by-step-section .section-title-area": {
      "margin-bottom": "50px",
    },
    ".step-by-step-section .section-title-area .section-subtitle": {
      "font-size": "16px",
      "font-weight": "600",
      color: "rgb(255 73 124 / 100)",
      "background-color": "rgb(255 73 124 / 0.2)",
      padding: "5px 20px",
      "border-radius": "15px",
      "margin-bottom": "15px",
    },
    ".step-by-step-section .section-title-area .section-title": {
      "font-size": "44px",
      "font-weight": "600",
      color: "rgb(0 0 0 / 100)",
    },
    ".step-by-step-section .stepdiv": {
      padding: "10px",
      "text-align": "center",
    },
    ".step-by-step-section .stepdiv .step-count": {
      width: "60px",
      height: "60px",
      color: "rgb(255 255 255 / 100)",
      "font-size": "30px",
      "font-weight": "600",
      padding: "12px 5px",
      "margin-bottom": "30px",
      "background-color": "rgb(255 73 124 / 100)",
      "border-radius": "50%",
    },
    ".step-by-step-section .stepdiv h4": {
      color: "rgb(0 0 0 / 100)",
      "font-weight": "600",
      "font-size": "20px",
      "margin-bottom": "15px",
    },
    ".step-by-step-section .stepdiv p": {
      color: "rgb(127 127 127 / 100)",
      "font-weight": "300",
      "font-size": "14px",
      "line-height": "1.6",
    },
    stepId: "",
  });
  const [boxSection, setBoxSection] = useState(false);
  const [id, setId] = useState("");
  const [childId, setChildId] = useState("");
  const [navMapId, setNavMapId] = useState("");
  const [galleryImgId, setGalleryImgId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isParent, setIsParent] = useState(false);
  const [filter, setFilter] = useState("");
  const [theme, setTheme] = useState(false);
  const [imgShow, setImgShow] = useState(false);
  const [sectionPageName, setSectionPageName] = useState("");
  return (
    <StepsContext.Provider
      value={{
        apiData,
        setApiData,
        apiDataOurTeam,
        setApiDataOurTeam,
        fromData,
        setFormData,
        id,
        setId,
        isEdit,
        setIsEdit,
        filter,
        setFilter,
        skill,
        galleryImgId,
        setGalleryImgId,
        setSkill,
        settingFormData,
        setSettingFormData,
        formDataChild,
        setFormDataChild,
        isParent,
        setIsParent,
        childId,
        setChildId,
        navMapId,
        setNavMapId,
        backImageToggle,
        setBackImageToggle,
        boxSection,
        setBoxSection,
        collId,
        setCollId,
        isBackgroundColor,
        setIsBackgroundColor,
        theme,
        setTheme,
        imgShow,
        setImgShow,
        sectionPageName,
        setSectionPageName,
        imageIs,
        setImageIs,
      }}
    >
      {props.children}
    </StepsContext.Provider>
  );
};

export default StepsState;
